(function (root) {
  'use strict';
  function createCampaign(settings) {
    const locale = (settings.locale || 'en').slice(0, 2);
    const copy = settings.copy[locale] || settings.copy.en;
    const currency = settings.currency || 'EUR';
    const discounts = settings.discounts[currency] || {};
    const products = settings.products;
    const bySlug = new Map(Object.values(products).filter(p => p.slug).map(p => [p.slug, p]));
    function amount(product) {
      const item = products[String(product.id || '')] || bySlug.get(product.slug);
      return item ? Number(discounts[item.group] || 0) : 0;
    }
    const money = cents => new Intl.NumberFormat(locale, { style: 'currency', currency, maximumFractionDigits: 2 }).format(cents / 100);
    function prepareProduct(product) {
      const original = Number(product.q4Original === undefined ? product.price : product.q4Original);
      const saving = amount(product);
      if (!saving || !Number.isFinite(original) || original <= saving) return product;
      return Object.assign({}, product, { q4Original: original, q4Saving: saving, price: original - saving, priceText: money(original - saving) });
    }
    function priceNode(original, saving) {
      const wrapper = document.createElement('span'); wrapper.className = 'q4-price'; wrapper.dataset.q4Price = '';
      const old = document.createElement('s'); old.className = 'q4-price__old'; old.textContent = money(original); old.setAttribute('aria-label', copy.before);
      const current = document.createElement('span'); current.className = 'q4-price__new'; current.textContent = money(original - saving); current.setAttribute('aria-label', copy.after);
      const badge = document.createElement('span'); badge.className = 'q4-price__saving'; badge.textContent = copy.save + ' ' + money(saving);
      wrapper.append(old, current, badge); return wrapper;
    }
    function applyConfig(config, market, slug) {
      if (config.q4Campaign) return config;
      const marketCurrency = market.currency || config.quoteSettings?.currency || currency;
      const table = settings.discounts[marketCurrency];
      if (!table) return config;
      const rule = bySlug.get(slug);
      if (!rule) return config;
      const multiplier = 1 + Number(market.vatRate || 0);
      const saving = Number(table[rule.group] || 0) / 100;
      const original = Number(config.basePrice);
      if (!(saving > 0 && original * multiplier > saving)) return config;
      config.q4Campaign = { originalBaseNet: original, baseGrossSaving: saving, multiplier, optionSavings: {} };
      config.basePrice = original - saving / multiplier;
      // Only whole additional baths qualify. Heaters, accessories, delivery and services stay unchanged.
      for (const stepId of ['cold-plunge', 'hot-tubs']) {
        for (const option of config.stepData?.[stepId]?.options || []) {
          const eligible = /^(cold-plunge-ice-bath-|hot-tubs-hot-tub-)/.test(option.id || '');
          const bathSaving = Number(table.bath || 0) / 100;
          if (!eligible || !(Number(option.price) * multiplier > bathSaving)) continue;
          config.q4Campaign.optionSavings[option.id] = bathSaving;
          option.q4OriginalNet = option.price;
          option.price -= bathSaving / multiplier;
        }
      }
      return config;
    }
    function selectedSaving(config, selections) {
      const campaign = config?.q4Campaign;
      if (!campaign) return 0;
      let total = campaign.baseGrossSaving;
      for (const key of ['cold-plunge', 'hot-tubs']) {
        const selected = selections?.[key];
        for (const id of (Array.isArray(selected) ? selected : [selected])) total += campaign.optionSavings[id] || 0;
      }
      return total;
    }
    function prepareQuote(body, config, displayedTotal, region, regionLabel) {
      if (config?.q4Campaign) {
        // The embedded total includes standard freight even when its default card is unselected.
        if (!body.selections.delivery?.length && config.stepData?.delivery?.options?.some(option => option.id === 'delivery-standard')) {
          body.selections.delivery = ['delivery-standard'];
        }
        body.campaignId = 'q4-2026-autumn-v1';
        body.campaignDisplayedTotal = displayedTotal;
        if (body.bundle && region) {
          body.bundleDeliveryRegionId = region.id;
          body.deliveryLocationLabel = regionLabel;
          body.deliveryToBeConfirmed = region.tbd === true;
        }
      }
      // The production endpoint validates all three reserved test-identity markers.
      if (/^configurator-qa\+[a-z0-9._-]+@example\.com$/i.test(body.customerEmail || '') &&
          (body.customerName || '').startsWith('[AUTOMATED QA - DO NOT CONTACT]')) {
        // Bundle forms have no notes field. Reserved identities still supply all server QA markers.
        body.notes = (body.notes || '') + '\nSAUNAMO_CONFIGURATOR_QA_V1';
        body.qaMode = true;
      }
      return body;
    }
    function quoteResult(body, result, origin) {
      if (!body.qaMode || !result.qaMode || !result.deliverySuppressed || !result.quoteId) return;
      const link = document.createElement('a');
      link.href = origin + '/quote/' + encodeURIComponent(result.quoteId);
      link.textContent = 'Open test quote · ' + money(Math.round(result.total * 100));
      link.id = 'q4-qa-quote-link';
      link.style.cssText = 'display:block;padding:20px;border:1px solid currentColor;margin:20px 0';
      const section = document.querySelector('#dyn-configurador');
      section?.append(link);
    }
    return { amount, money, prepareProduct, priceNode, applyConfig, selectedSaving, prepareQuote, quoteResult, copy, currency };
  }
  if (typeof module !== 'undefined' && module.exports) module.exports = { createCampaign };
  if (!root?.document || !root.SaunamoQ4Config) return;
  const settings = root.SaunamoQ4Config;
  const campaign = root.SaunamoQ4 = createCampaign(settings);
  function decorate() {
    const saving = campaign.amount({ id: settings.productId });
    if (!saving) return;
    document.querySelectorAll('.wz-pc-price .v').forEach(node => {
      if (node.querySelector('[data-q4-price]')) return;
      const text = node.textContent.replace(/[^0-9.,]/g, '');
      let major = Number(text.replace(/[.,](?=\d{3}(?:[.,]|$))/g, '').replace(',', '.'));
      if (Number.isFinite(major) && major > 0) node.replaceChildren(campaign.priceNode(Math.round(major * 100) + saving, saving));
    });
    document.querySelectorAll('[data-sm-hot-tub-total-price]').forEach(node => {
      if (node.querySelector('[data-q4-price]')) return;
      const base = Number(node.dataset.basePrice);
      let extras = 0;
      const form = node.closest('form');
      form?.querySelectorAll('[data-sm-hot-tub-addon-toggle]:checked').forEach(input => { extras += Number(input.dataset.smHotTubAddonPrice || 0); });
      if (base > 0) node.replaceChildren(campaign.priceNode(base + extras + saving, saving));
    });
  }
  let frame;
  function queueDecorate() { if (frame) return; frame = requestAnimationFrame(() => { frame = null; decorate(); }); }
  function ready() {
    // A merchant preview may change display prices, but must never issue a full-price real quote/order.
    if (settings.mode === 'preview') {
      const explain = event => {
        event.preventDefault(); event.stopImmediatePropagation();
        const existing = document.querySelector('.q4-review-action'); existing?.remove();
        const message = document.createElement('p'); message.className = 'q4-config-note q4-review-action'; message.textContent = 'Campaign preview only. Pricing must be activated before submitting a quote or order.';
        const target = event.target.closest('form,.wz-rec-bundle,.wz-lead-form') || event.target.parentElement; target?.append(message);
      };
      document.addEventListener('submit', event => {
        if (event.target.matches('form[action*="/cart/add"]') || (!settings.quotePricingReady && event.target.closest('#dyn-configurador'))) explain(event);
      }, true);
      document.addEventListener('click', event => {
        if (event.target.closest('[data-sm-direct-buy-button]') || (!settings.quotePricingReady && event.target.closest('#wzDynLeadSubmit,#smRecLeadSubmit,.wz-rec-bundle__btn.is-buy'))) explain(event);
      }, true);
    }
    new MutationObserver(queueDecorate).observe(document.body, { childList: true, subtree: true });
    decorate();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, { once: true }); else ready();
})(typeof window === 'undefined' ? null : window);
